import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface CardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  headerAction?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  noPadding?: boolean;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
}

export function Card({
  title,
  subtitle,
  headerAction,
  footer,
  children,
  noPadding = false,
  className,
  headerClassName,
  bodyClassName,
}: CardProps) {
  const hasHeader = Boolean(title || subtitle || headerAction);

  return (
    <div
      className={cn(
        'rounded-card border border-line bg-white shadow-card transition-colors dark:border-slate-800 dark:bg-slate-900',
        className,
      )}
    >
      {hasHeader && (
        <div
          className={cn(
            'flex flex-wrap items-center justify-between gap-3 border-b border-line px-5 py-4 dark:border-slate-800',
            headerClassName,
          )}
        >
          <div className="min-w-0">
            {title && (
              <h3 className="text-base font-bold text-ink dark:text-slate-100">{title}</h3>
            )}
            {subtitle && (
              <p className="mt-0.5 text-xs text-ink-3 dark:text-slate-400">{subtitle}</p>
            )}
          </div>
          {headerAction && <div className="ms-auto shrink-0">{headerAction}</div>}
        </div>
      )}

      <div className={cn(!noPadding && 'p-5', bodyClassName)}>{children}</div>

      {footer && (
        <div className="border-t border-line px-5 py-3.5 dark:border-slate-800">
          {footer}
        </div>
      )}
    </div>
  );
}

export default Card;
